import React, { Fragment } from 'react';
import { getPaginatorObject, searchWithFilter, getSelectedLimit } from './jobs-filter/CareersPageFilterService';
import { CS_Radio, CS_Space, CS_Text, CS_Dropdown, CS_Row, CS_Pagination } from '../visual_components';

export default function ListFooter() {
	const page_counts = [10, 25, 50, 100];
	const selected_jobs_per_page = getSelectedLimit();
	const paginator = getPaginatorObject();
	return (
		<Fragment>
			<CS_Space size={5} vertical={true} />
			<CS_Row vcenter={true} right_aligned={true}>
				<CS_Space size={2} vertical={true} />
				<CS_Text size={4}>Jobs Per Page</CS_Text>
				<CS_Space size={2} />
				<CS_Dropdown id="job_per_page_dropdown" value={selected_jobs_per_page}>
					{page_counts.map(val => (
						<CS_Radio
							key={`page_count_${val}`}
							name={'limit'}
							value={val}
							defaultChecked={selected_jobs_per_page === val}
							onChange={searchWithFilter}>
							{val}
						</CS_Radio>
					))}
				</CS_Dropdown>
				<CS_Space size={2} />
				<CS_Pagination {...paginator} />
			</CS_Row>
		</Fragment>
	);
}
